module.exports = __webpack_public_path__ + "static/img/buddy_mini_pictgrid11_800x745.c12be44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_mini_pictgrid11_800x745.jpg
// module id = ceyS
// module chunks = 0